import Compressor from 'compressorjs'

import { Sentry } from '~/clients/sentry'

export const getCompressedImage = (file: File): Promise<string> =>
  new Promise(
    async (resolve, reject) =>
      new Compressor(file, {
        checkOrientation: true,
        strict: true,
        quality: 0.7,
        maxWidth: 2048,
        success: (compressedFile: File | Blob) => {
          const reader = new FileReader()

          reader.onloadend = () => resolve(reader.result as string)
          reader.readAsDataURL(compressedFile)
        },
        error: (error: Error) => {
          Sentry.captureException({
            errorName: 'ERROR_WHILE_COMPRESSING_IMAGE_ON_CLIENT',
            errorMessage: error.message,
            filePath: 'src/utils/compressImage/index.ts',
            functionName: 'compressImage',
            payload: {
              fileName: file.name,
              fileType: file.type,
              fileSize: file.size,
            },
          })

          reject(new Error('Error while compressing the image on the client'))
        },
      }),
  )
